import React from 'react';
import styles from '../irlObservations2026.module.css';
import { ModalShell } from '../chrome';

export default function IRL_AI_Review({ modes, onSelect, onCancel }) {
    return (
        <ModalShell>
            <div className={styles.modalHead}>
                <h2 className={styles.modalTitle}>AI Review</h2>
                <button type="button" className={styles.modalClose} onClick={onCancel} aria-label="Close">
                    ×
                </button>
            </div>
            <div className={styles.modalBody}>
                <p className={styles.modalIntro}>Use Lens to review requests, responses and available project evidence. Lens suggestions require human confirmation before they become project records.</p>
                {modes.map(mode => (
                    <button key={mode.id} type="button" className={styles.modeCard} onClick={() => onSelect(mode.id)}>
                        <p className={styles.modeTitle}>{mode.title}</p>
                        <p className={styles.modeDesc}>{mode.description}</p>
                    </button>
                ))}
            </div>
            <div className={styles.modalFoot}>
                <button type="button" className={styles.outlineBtn} onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </ModalShell>
    );
}
